import React, { useContext } from 'react';
import classnames from 'classnames';
import { Url } from '@wix/da-url';
import { useTranslation, Trans } from 'react-i18next';
import { SessionContext } from '@wix/da-react-context/pkg/SessionContext';
import UserLink from '../../../User/Link/UserLink';
import TextButton from '@wix/da-ds/pkg/Buttons/TextButton';
import { formatDate, DATE_FORMATS } from '../../../Timestamp/functions';
import LegacyTextRenderer from '../../../TextRenderer/LegacyTextRenderer';
import deviationFlagStyles from './DeviationFlags.scss';
var DailyDeviationCard = function (_a) {
    var _b = _a.dailyDeviation, body = _b.body, time = _b.time, giver = _b.giver, suggester = _b.suggester;
    var t = useTranslation().t;
    var isLoggedIn = useContext(SessionContext).isLoggedIn;
    return (React.createElement("div", { className: classnames(deviationFlagStyles['flag-block'], deviationFlagStyles['open']) },
        React.createElement("div", { className: classnames(deviationFlagStyles['flag'], deviationFlagStyles['green']) }),
        React.createElement("div", { className: deviationFlagStyles['content'] },
            React.createElement("div", { className: deviationFlagStyles['title'] }, t('actionbar.flags.dailyDeviation')),
            React.createElement("div", { className: deviationFlagStyles['open-only'] },
                React.createElement("div", { className: deviationFlagStyles['time'], suppressHydrationWarning: true }, t('actionbar.flags.givenOn', {
                    date: formatDate(time, DATE_FORMATS.Date.Full),
                })),
                React.createElement(LegacyTextRenderer, { className: deviationFlagStyles['body'], html: body }),
                React.createElement("div", { className: deviationFlagStyles['attribution'] },
                    React.createElement("div", { className: deviationFlagStyles['giver'] },
                        React.createElement(Trans, { i18nKey: "actionbar.flags.featuredBy" },
                            "Featured by ",
                            React.createElement(UserLink, { user: giver, className: deviationFlagStyles['link'] }))),
                    suggester && (React.createElement("div", { className: deviationFlagStyles['suggester'] },
                        React.createElement(Trans, { i18nKey: "actionbar.flags.suggestedBy" },
                            "Suggested by ",
                            React.createElement(UserLink, { user: suggester, className: deviationFlagStyles['link'] }))))),
                isLoggedIn && (React.createElement(TextButton, { href: Url.browseDailyDeviationsLink(), size: "medium", variant: "approval-green", noSpaceAround: false }, t('actionbar.flags.seeAll')))))));
};
DailyDeviationCard.displayName = 'DailyDeviationCard';
export default DailyDeviationCard;
//# sourceMappingURL=DailyDeviationCard.js.map